import React from 'react';
import Adds from './add';
import Address from './address';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/server';

class Title extends React.Component {

  state = {

  }

  moveToMachineCustomer = (id) => {
    let context = this;
    $.ajax({
      data: { id },
      type: 'POST',
      url: Server()+'machinecustomer/MoveToMachineCustomer.php',
      success: function(data) {
        console.log(data);
        if (data == 1 || data == '1') {
          context.props.search();
        }
        else {
          alert('Error')
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  render() {
    let i = 0;
    return (
      <div>
        <table id="table" width="100%">
          <tr>
            <td id="tableheader"><center>Sino</center></td>
            <td id="tableheader"><center>Name</center></td>
            <td id="tableheader"><center>Mobile</center></td>
            <td id="tableheader"><center>Alt Mobile</center></td>
            <td id="tableheader"><center>Email</center></td>
            <td id="tableheader"><center>Move</center></td>
            { this.props.menuPermission.edit ?
              <td id="tableheader" style={{width: '5%', display: this.props.machinecustomeredit}}>
                <center>Edit</center>
              </td>:''
            }
            
            <td id="tableheader" style={{width: '10%', display: this.props.machinecustomeredit}}>
              <center>Address</center>
            </td>
          </tr>
          { this.props.data.map((x) => {
              i++;
              return (
                <tbody>
                  <tr>
                    <td><center>{i}</center></td>
                    <td><div>{x.id+"->"+x.name}</div></td>
                    <td><center>{x.mobile}</center></td>
                    <td><center>{x.alt_mobile}</center></td>
                    <td><center>{x.email}</center></td>
                    <td><center onClick={ () => this.moveToMachineCustomer(x.id)}>Move To Machine Customer</center></td>
                    { this.props.menuPermission.edit ?
                      <td style={{cursor: 'pointer'}}>
                        <center>
                          <Adds getMachineCustomer={this.props.getMachineCustomer}
                                type='edit' data={this.props.data} id={x.id} />
                        </center>
                      </td>:''
                    }
                    <td style={{cursor: 'pointer'}}>
                      <center>
                        <Address menuPermission={this.props.menuPermission} cid={x.id} />
                      </center>
                    </td>
                  </tr>
                </tbody>
              )
            })
          }
        </table>
      </div>
    );
  }
}

export default Title;
